import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/bootstrap.min.css";
import "../css/bootstrap-select.min.css";
import "../css/fontawesome/css/font-awesome.min.css";
import "../css/owl.carousel.min.css";
import "../css/magnific-popup.min.css";
import "../css/loader.min.css";
import "../css/flaticon.min.css";
import "../css/style.css";
import "../css/bootstrap-slider.min.css";
import "../css/skin/skin-1.css";

import ledlightsbanner from "../img/services/led-lights/led-lights-banner.jpg";
import ledlightsmanufacturing from "../img/services/led-lights/led-lights-manufacturing.jpg";
import ledmachinery from "../img/services/led-lights/led-machinery.jpg";
import crossline2 from "../images/background/cross-line2.png";
import ledlightsspinoff1 from "../img/services/led-lights/led-lights-spinoff1.jpg";
import ledlightsspinoff2 from "../img/services/led-lights/led-lights-spinoff2.jpg";
import ledlightsspinoff3 from "../img/services/led-lights/led-lights-spinoff3.jpg";
import ledlightsspinoff4 from "../img/services/led-lights/led-lights-spinoff4.jpg";
import ledlightsspinoff5 from "../img/services/led-lights/led-lights-spinoff5.jpg";
import ledlightsspinoff6 from "../img/services/led-lights/led-lights-spinoff6.jpg";
import ledlightsspinoff7 from "../img/services/led-lights/led-lights-spinoff7.jpg";
import ledlightsspinoff8 from "../img/services/led-lights/led-lights-spinoff8.jpg";
import ledlightsspinoff9 from "../img/services/led-lights/led-lights-spinoff9.jpg";
import ledlightsspinoff10 from "../img/services/led-lights/led-lights-spinoff10.jpg";

import LedLightsCatalogue1 from '../catalogues/ledlights/catalogue1-1.pdf';
import LedLightsCatalogue2 from '../catalogues/ledlights/catalogue2-1.pdf';
import LedLightsCatalogue3 from '../catalogues/ledlights/catalogue3-1.pdf';
import LedLightsCatalogue4 from '../catalogues/ledlights/catalogue4-1.pdf';
import LedLightsCatalogue5 from '../catalogues/ledlights/catalogue5-1.pdf';
import FancyCatalogue from '../catalogues/ledlights/fancy-lights-catalogue.pdf';

import ledvideo from '../video/ledvideo.mp4';

function Ledlights() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 3); // Loop through 3 slides
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="page-content">
      {/* INNER PAGE BANNER */}
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${ledlightsbanner})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">LED Lights Manufacturing</h2>
                <p>
                  Redefining illumination with durable, modern LED solutions
                  designed for lasting performance and efficiency
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* INNER PAGE BANNER END */}
      {/* SECTION CONTENT START */}
      <div className="section-full p-t80 p-b50 mobile-page-padding">
        <div className="container">
          {/* GALLERY CONTENT START */}
          <div className="row">
            <div className="col-lg-4 col-md-12 sticky_column">
              <div className="about4-section m-b20 bg-gray p-a20">
                {/*
                <div className="widget widget_services">
                  <h4 className="widget-title">Our Business Verticals</h4>
                  <ul className="bg-white">
                    <li>
                      <Link to="/our-services/lithium-battery">
                        Lithium Battery
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/inverter-ups">
                        Inverter & UPS
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-services/sheet-metal">
                        CNC Lazer Cut Machines
                      </Link>
                    </li>
                  </ul>
                </div>*/}
                <div className="wt-icon-box-wraper left p-a15 m-b10">
                <a href="/catalogues/ledlights/catalogue1.pdf" className="btn-block" target="_blank">
                    <strong className="text-uppercase text-black">
                
                    </strong>
                  </a>
                </div>
                <h4>Our Product Range in LED Lights</h4>
                <div className="wt-icon-box-wraper left p-a15 m-b10">
                  <a
                    href="#"
                    className="btn-block"
                    target="_blank"
                  >
                  
                    <strong className="text-uppercase text-black">
                   
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LedLightsCatalogue1}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Imperial Lights Catalogue - 1
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LedLightsCatalogue2}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Imperial Lights Catalogue - 2 
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LedLightsCatalogue3}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Imperial Lights Catalogue - 3
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LedLightsCatalogue4}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Imperial Lights Catalogue - 4
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={LedLightsCatalogue5}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Imperial Lights Catalogue - 5
                    </strong>
                  </a>
                </div>
                <div className="wt-icon-box-wraper left bg-white p-a15 m-b10">
                  <a
                    href={FancyCatalogue}
                    className="btn-block"
                    target="_blank"
                  >
                    <span className="text-black m-r10">
                      <i className="fa fa-file-pdf-o" />
                    </span>
                    <strong className="text-uppercase text-black">
                      Finike Lights - Decorative Lights Catalogue 
                    </strong>
                  </a>
                </div>
                {/*
                <div className="about4-content m-t30">
                  <h4>GET SPECIAL OFFER</h4>
                  <p>Contact us Now and Get Special Offer on your Projects</p>
                  <a
                    href="https://wa.link/jb4lfe"
                    className="site-button-link"
                    target="_blank"
                  >
                    Chat with us!
                  </a>
                </div>*/}
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="section-content">
                <div className="service-single-block m-b30">
                  <div className="sx-media">
                    <img src={ledlightsmanufacturing} alt="" />
                  </div>
                  <h3 className="m-t30 sx-tilte">
                    Exploring Spinoff Technopark's LED Lighting Solutions
                  </h3>
                  <p>
                    At Spinoff Technopark Ltd., we are dedicated to
                    illuminating the future with cutting-edge LED lighting
                    solutions that redefine efficiency, durability, and
                    innovation. As a leader in the manufacturing industry, we
                    specialize in a diverse range of LED lighting products
                    tailored to meet the dynamic needs of various sectors.
                  </p>
                  <h4 className="m-t30 sx-tilte">
                    Our extensive product line includes:-
                  </h4>
                  <div className="single-service-list">
                    <div className="row">
                      <div className="col-lg-6 col-md-12">
                        <ul className="list-angle-right anchor-line">
                          <li>
                            <b>Architectural Lighting :- </b>We manufacture
                            architectural lighting solutions that combine
                            aesthetics with functionality, enhancing the design
                            and ambiance of spaces
                          </li>
                          <li>
                            <b>Lighting Automation :- </b>We offer lighting
                            automation systems that provide seamless control,
                            enhancing energy efficiency, convenience, and
                            ambiance in any space.
                          </li>
                          <li>
                            <b>Customized Lighting Solution :- </b>We provide
                            customized lighting solutions tailored to meet
                            specific design needs, ensuring optimal
                            functionality and aesthetic appeal
                          </li>
                          <li>
                            <b>Decorative Lighting Solution :- </b>We offer
                            decorative LED lighting solutions, including wall
                            lamps, table lamps, chandeliers, and garden lights,
                            enhancing any space with style.
                          </li>
                          <li>
                            <b>COB Lights :- </b>Compact and powerful, our
                            Chip-on-Board (COB) lights deliver concentrated
                            lighting solutions ideal for industrial and
                            commercial applications.
                          </li>
                          <li>
                            <b>Outdoor Lights :- </b>From rugged streetlights to
                            elegant garden fixtures, our outdoor lighting
                            solutions ensure safety, security, and aesthetic
                            appeal in every environment.
                          </li>
                        </ul>
                      </div>
                      <div className="col-lg-6 col-md-12">
                        <ul className="list-angle-right anchor-line">
                          <li>
                            <b>LED Lights :- </b>Offering unparalleled energy
                            efficiency and longevity, our LED lights are
                            designed to enhance both indoor and outdoor spaces
                            with bright, crisp illumination.
                          </li>
                          <li>
                            <b>Pharma Lights :- </b>Designed with precision for
                            pharmaceutical facilities, our specialized pharma
                            lights meet stringent requirements for clean rooms
                            and sterile environments.
                          </li>
                          <li>
                            <b>Up-Down Lights :- </b>Versatile and stylish, our
                            up-down lights provide ambient lighting that
                            enhances architectural features while optimizing
                            visual comfort
                          </li>
                          <li>
                            <b>Magnetic Lights :- </b>Easy to install and
                            adjust, our magnetic lights offer flexible lighting
                            solutions suitable for diverse settings from offices
                            spaces
                          </li>
                          <li>
                            <b>Underwater Lights :- </b>Built to withstand
                            underwater conditions, our underwater lights combine
                            durability with exceptional brightness for pools
                            &amp; fountains applications
                          </li>
                          <li>
                            <b>Highbay Lights :- </b>Designed for large indoor
                            spaces, our highbay lights offer superior brightness
                            and uniformity, making them ideal for warehouses,
                            factories, and gymnasiums
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="sx-media sx-img-effect zoom-slow">
                    <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                      <img src={ledmachinery} alt="" />
                      <a
                        href={ledvideo}
                        className="mfp-video play-now"
                        target="_blank"
                      >
                        <i className="icon fa fa-play" />
                        <span className="ripple" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="sx-accordion acc-bg-gray m-b30" id="accordion5">
                  <div class="panel sx-panel">
                    <div class="acod-head acc-actives">
                      <h6 class="acod-title">
                        <a
                          data-toggle="collapse"
                          href="#collapseOne5"
                          data-parent="#accordion5"
                        >
                          Why Choose Spinoff Technopark?
                          <span class="indicator">
                            <i class="fa"></i>
                          </span>
                        </a>
                      </h6>
                    </div>
                    <div id="collapseOne5" class="acod-body collapse show">
                      <div class="acod-content p-tb15">
                        <p>
                          Choose Spinoff Technopark for cutting-edge LED
                          solutions: unmatched efficiency, durability, and
                          tailored designs. Transform spaces with sustainable,
                          high-performance lighting trusted worldwide.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* GALLERY CONTENT END */}
        </div>
        {/* Similar projects START */}

        {/* Similar projects END */}
      </div>
    </div>
  );
}

export default Ledlights;
